// EventBus.js
class EventBus {
  constructor() {
    this.subscribers = {};
  }

  dispatch(event, arg) {
    const subscriber = this.subscribers[event];
    if (subscriber === undefined) {
      return;
    }
    Object.keys(subscriber).forEach((key) => subscriber[key](arg));
  }

  register(event, callback) {
    const id = `id_${Math.random().toString(36).substr(2, 9)}`;
    if (!this.subscribers[event]) {
      this.subscribers[event] = {};
    }
    this.subscribers[event][id] = callback;
    return {
      unregister: () => {
        delete this.subscribers[event][id];
        if (Object.keys(this.subscribers[event]).length === 0) {
          delete this.subscribers[event];
        }
      },
    };
  }
}

// Exporting a singleton instance
const eventBus = new EventBus();
export default eventBus;
